import { NavLink, useLocation } from "react-router-dom";
import { navItemFor } from "@/config/redesignNavItems";
import { cn } from "@/lib/utils";

/**
 * The pages one nav item stands for, as tabs under the page header (redesign
 * phase 1). Plan, Activity, Upcoming and Insights each fold several of today's
 * pages together and their own specs are still to come, so until then this row is
 * how Budgets, Goals, Debt, Rules, Bills & income and Review my data stay one click
 * away. Renders nothing on Home and on the account pages.
 */
export function SectionTabs() {
  const { pathname } = useLocation();
  const item = navItemFor(pathname);
  if (!item || item.sections.length < 2) return null;
  return (
    // Item 11 (Paul, 2026-10-20): the tabs wrap onto a second row instead of scrolling
    // the strip sideways. At 390 the Plan row already hid "Debt Eliminator" off the edge,
    // and at 200% text four of its five tabs, so a section was one swipe away and unseen.
    <nav aria-label={`${item.label} pages`} className="mb-4">
      <ul
        role="list"
        data-tab-row
        className="inline-flex max-w-full flex-wrap gap-1 rounded-xl bg-muted p-1"
      >
        {item.sections.map((section) => (
          <li key={section.to} role="listitem">
            <NavLink
              to={section.to}
              end
              className={({ isActive }) =>
                cn(
                  "tap-target block whitespace-nowrap rounded-lg px-3 py-1.5 text-sm font-medium transition-colors",
                  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                  isActive
                    ? "bg-card text-foreground shadow-sm"
                    : "text-muted-foreground hover:text-foreground",
                )
              }
            >
              {section.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
